import React from 'react';
import { useFilterContext } from '../../context/filter_context';
import { useLanguageContext } from '../../context/language_context';
import { BsFillGridFill, BsList } from 'react-icons/bs';
import Wrapper from './styles';

const Sort = () => {
  const { t, isArabic } = useLanguageContext();
  const {
    filtered_products: products,
    grid_view,
    sort,
    setGridView,
    setListView,
    updateSort,
  } = useFilterContext();

  return (
    <Wrapper style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <div className='btn-container'>
        <button
          type='button'
          className={`${grid_view ? 'active' : null}`}
          onClick={setGridView}
        >
          <BsFillGridFill />
        </button>
        <button
          type='button'
          className={`${!grid_view ? 'active' : null}`}
          onClick={setListView}
        >
          <BsList />
        </button>
      </div>
      <p>{products.length} {t.nav.products}</p>
      <hr />
      <form>
        <label htmlFor='sort'>{t.products.sortBy}</label>
        <select
          name='sort'
          id='sort'
          className='sort-input'
          value={sort}
          onChange={updateSort}
        >
          <option value='price-lowest'>{t.products.lowestPrice}</option>
          <option value='price-highest'>{t.products.highestPrice}</option>
          <option value='name-a'>{t.products.nameAZ}</option>
          <option value='name-z'>{t.products.nameZA}</option>
        </select>
      </form>
    </Wrapper>
  );
};

export default Sort;
